'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
class FixedPanelWrapper extends Component {
  componentWillLeave(callback) {
    const {
      transitionSpeed
    } = this.props;
    // No classes are applied, we just wait for the transitionSpeed to pass before
    // telling TransitionGroup that it can remove the component
    // That way, it stays in the same place on the DOM so that the edit panel can
    // slide over it
    setTimeout(() => {
      callback();
    }, transitionSpeed);
  }
  render() {
    const {
      children,
      className
    } = this.props;
    return /*#__PURE__*/_jsx("div", {
      className: className,
      children: children
    });
  }
}
FixedPanelWrapper.propTypes = {
  transitionSpeed: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};
export default FixedPanelWrapper;